import { useState } from "react";
import { useFormik, FormikErrors } from "formik";
import { OnboardingAddressTemplateProps } from "./template";
import { useUpdateAddress } from "@mutations";
import { useNavigate } from "react-router-dom";

export interface AddressFormValues {
  street: string;
  city: string;
  country: string;
  province: string;
  postalCode: string;
}

export const OnboardingAddressLogic = (): OnboardingAddressTemplateProps => {
  const [province, setProvince] = useState<string>("CA");
  const [country, setCountry] = useState<string>("CA");
  const [logo, setLogo] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const addPartnerAddress = useUpdateAddress();
  const navigate = useNavigate();
  const validateAddress = (values: AddressFormValues): FormikErrors<AddressFormValues> => {
    const errors: FormikErrors<AddressFormValues> = {};

    if (!values.street) {
      errors.street = "Street is required";
    } else if (!values.city) {
      errors.city = "City is required";
    } else if (!country) {
      errors.city = "Country is required";  
    } else if (!province) {
      errors.city = "Province is required";
    } else if (!values.postalCode) {
      errors.city = "Postal code is required";
    }
    return errors;
  };

  const { values: valuesAddress, errors: errorsAddress, handleChange: handleChangeAddress, handleSubmit: handleSubmitAddress } = useFormik<AddressFormValues>({
    initialValues: {
      street: "",
      city: "",
      country: country,
      province: province,
      postalCode: "",
    },
    validate: validateAddress,
    validateOnChange: false,
    onSubmit: async (values: AddressFormValues) => {
        console.log("address onSubmit called:");
        console.log({...values, province, country});
        setIsLoading(true);

        try {
          await addPartnerAddress(
            values.street as string,
            values.city as string,
            province,
            country,
            values.postalCode as string,
          );
          setIsLoading(false);
          navigate("/dashboard/upload-logo");
          return;
        } catch (error: any) {
          console.log(error);
        }
      },
  });

  const handleInputChangeProvince = (e: any) => {
    setProvince(e.value);
  };
  const handleInputChangeCountry = (e: any) => {
    setCountry(e.value);
    setProvince("");
  };

  const handleInputChangeAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleChangeAddress(e);
  }

  return {
    values: valuesAddress,
    errors: errorsAddress,
    handleSubmit: handleSubmitAddress,
    handleInputChangeAddress,
    handleInputChangeProvince,
    handleInputChangeCountry,
    setLogo,
    logo,
    province,
    country,
    isLoading,
  };
}; 